import { ErrorTypes } from '@wix/form-validator';
import { DerivedErrorTypes } from '../../field-error/error-types';
import { multipleOfToDisplayValue } from '../../field-settings/settings-shared/decimal-setting/decimal-setting-utils';
export const getPattern = multipleOf => {
  var _String$split;
  const decimals = ((_String$split = String(multipleOf).split('.')) == null || (_String$split = _String$split[1]) == null ? void 0 : _String$split.length) || 0;
  const regex = multipleOf === 1 || typeof multipleOf === 'undefined' || multipleOf === null ? `^-?\\d*?$` : `^-?\\d*(\\.\\d{0,${decimals}})?$`;
  return regex;
};
export const getValidNumberInput = (input, multipleOf, previousValidValue, locale) => {
  if (input.trim() === '') {
    return {
      validInput: '',
      validNumber: undefined
    }; // allow clear input
  }
  const inputNumber = inputToNumber(input);
  if (isNumberInputValid(inputNumber, multipleOf) && inputNumber < Number.MAX_SAFE_INTEGER) {
    return {
      validInput: localizeNumberInput(input, locale),
      validNumber: inputNumber
    };
  }
  return previousValidValue ? {
    validInput: previousValidValue,
    validNumber: inputToNumber(previousValidValue)
  } : {
    validInput: '',
    validNumber: undefined
  };
};
const inputToNumber = input => Number(input.replace(',', '.'));
export const localizeNumberInput = (input, locale) => {
  var _Intl$NumberFormat$fo;
  const decimalSeparator = locale ? (_Intl$NumberFormat$fo = Intl.NumberFormat(locale).formatToParts(1.1).find(part => part.type === 'decimal')) == null ? void 0 : _Intl$NumberFormat$fo.value : undefined;
  return decimalSeparator ? input.replace(/[.,]/, decimalSeparator) : input;
};
export const isNumberInputValid = (value, multipleOf) => {
  const multipleOfRegex = getPattern(multipleOf);
  const validator = new RegExp(multipleOfRegex);
  return validator.test(`${value}`);
};
export const getNumberInputError = (validation, error) => {
  var _validation$number, _validation$number2, _validation$number3;
  const isMinMaxValueError = (error == null ? void 0 : error.errorType) === ErrorTypes.MIN_VALUE_ERROR || (error == null ? void 0 : error.errorType) === ErrorTypes.MAX_VALUE_ERROR;
  const isMultipleOfValueError = (error == null ? void 0 : error.errorType) === ErrorTypes.MULTIPLE_OF_VALUE_ERROR;
  if (!error) {
    return error;
  }
  const minimum = validation == null || (_validation$number = validation.number) == null ? void 0 : _validation$number.minimum;
  const maximum = validation == null || (_validation$number2 = validation.number) == null ? void 0 : _validation$number2.maximum;
  const isMinMaxValues = minimum && maximum;
  const multipleOf = validation == null || (_validation$number3 = validation.number) == null ? void 0 : _validation$number3.multipleOf;
  if (isMinMaxValueError && isMinMaxValues && minimum !== maximum) {
    return {
      ...error,
      errorType: DerivedErrorTypes.VALUE_RANGE_ERROR,
      errorMessage: `must be from ${minimum} to ${maximum}`,
      params: {
        minLimit: minimum,
        maxLimit: maximum
      }
    };
  }
  if (isMultipleOfValueError && multipleOf) {
    const number = multipleOfToDisplayValue(multipleOf);
    return {
      ...error,
      errorType: DerivedErrorTypes.DECIMAL_POINT_ERROR,
      errorMessage: `must have ${number} number(s) after the decimal point`,
      params: {
        number
      }
    };
  }
  return error;
};
//# sourceMappingURL=numeric-input-utils.js.map